import React, { useState } from "react";
import { FaSearch } from "react-icons/fa";
import { useSearch } from "../../context/SearchContext";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./Symptom.scss";
import { useAuth } from "../../context/AuthContext";
import { useSearchToggle } from "../../context/SearchToggleContext";

const symptoms = [
    "lethargy",
    "diarrhea",
    "blood_in_stool",
    "gastro_distress",
    "fever",
    "weight_loss",
    "dehydration",
    "weakness",
    "pale_gums",
    "swollen_lymph_nodes",
    "coughing",
    "nasal_discharge",
    "labored_breathing",
    "rapid_breathing",
    "sneezing",
    "loss_of_appetite",
    "scratching",
    "skin_irritation",
    "hair_loss",
    "fleas",
    "flaky_skin",
    "sores",
    "excessive_licking",
    "worms_in_stool",
    "frequent_urination",
    "straining_to_urinate",
    "blood_in_urine",
    "foul_urine_odor",
    "mobility_issues",
    "joint_stiffness",
    "reluctance_to_move",
    "swollen_joints",
    "bad_breath",
    "swollen_gums",
    "excessive_drooling",
    "difficulty_chewing",
    "excessive_thirst",
    "excessive_urination",
    "hiding",
    "ear_irritation",
    "ear_discharge",
    "ear_odor",
    "head_shaking"
];

const SymptomSearch = () => {
  const [query, setQuery] = useState("");
  const [error, setError] = useState("");
  const { setSearchResult } = useSearch();
  const navigate = useNavigate();
  const [focusedIndex, setFocusedIndex] = useState(-1);
  const { setIsSearchVisible } = useSearchToggle();

  const handleChange = (e) => {
    setQuery(e.target.value);
  };

  const handleSelect = (symptom) => {
    let newQuery = query.split(",");
    newQuery[newQuery.length - 1] = symptom;
    setQuery(newQuery.join(", ") + ", ");
  };

  const handleKeyDown = (e) => {
    if (e.key === "ArrowDown") {
      setFocusedIndex((prev) =>
        prev < filteredSuggestions.length - 1 ? prev + 1 : 0
      );
    } else if (e.key === "ArrowUp") {
      setFocusedIndex((prev) =>
        prev > 0 ? prev - 1 : filteredSuggestions.length - 1
      );
    } else if (e.key === "Enter") {
      if (focusedIndex >= 0 && filteredSuggestions[focusedIndex]) {
        handleSelect(filteredSuggestions[focusedIndex]);
      } else {
        handleSearch();
      }
    }
  };
  

  const getCurrentInput = () => {
    const parts = query.split(",");
    return parts[parts.length - 1].trim();
  };

  const filteredSuggestions = symptoms.filter(
    (symptom) =>
      symptom.toLowerCase().includes(getCurrentInput().toLowerCase()) &&
      !query
        .split(",")
        .map((s) => s.trim())
        .includes(symptom)
  );

  const handleSearch = async () => {
    const symptomList = query
      .split(",")
      .map((s) => s.trim())
      .filter((s) => s);

    try {
      const res = await axios.post("/predict", { symptoms: symptomList });
      setSearchResult(res.data);
      console.log(res.data);
      setError("");
      navigate("/prediction");
    } catch (err) {
      setSearchResult(null);
      setError("Error fetching prediction. Please try again.");
    }
  };
  const { user } = useAuth();

  return (
    <>
      <div className="symptom-bar">
        <input
          disabled={!user}
          type="text"
          value={query}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          placeholder="Search for symptoms..."
        />
        <button className="search-btn" onClick={handleSearch}>
          <FaSearch style={{ color: "#ffffff" }} />
        </button>

        {getCurrentInput() && (
          <ul className="suggestions-list">
            {filteredSuggestions.length > 0 ? (
            filteredSuggestions.map((symptom, index) => {
              const lowerSymptom = symptom.toLowerCase();
              const input = getCurrentInput().trim().toLowerCase();
              const matchIndex = lowerSymptom.indexOf(input);

              if (matchIndex === -1) {
                return (
                  <li key={index} onClick={() => handleSelect(symptom)}>
                    {symptom}
                  </li>
                );
              }

      
              const beforeMatch = symptom.slice(0, matchIndex);
              const matchText = symptom.slice(
                matchIndex,
                matchIndex + input.length
              );
              const afterMatch = symptom.slice(matchIndex + input.length);

              return (
                <li key={index} onClick={() => handleSelect(symptom)}>
                  {beforeMatch}
                  <span className="highlight">{matchText}</span>
                  {afterMatch}
                  {error && ({error})}
                </li>
              );
            })
            ) : (
              <li className="no-suggestions">No suggestions available</li>
            )}
          </ul>
        )}
      </div>
    </>
  );
};

export default SymptomSearch;
